// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component[data-v-4688ee6b] {\n  text-align: center;\n}\n.paid[data-v-4688ee6b] {\n  background: #56af56;\n  color: white;\n  text-align: center;\n  border-radius: 3px;\n}\n.double-fine[data-v-4688ee6b] {\n  background: #ff6161;\n  color: white;\n  text-align: center;\n  border-radius: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
